import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Store the bound reference so disconnect() can remove exactly this listener
    // (bind() returns a new function each call).
    this.boundInit = this.init.bind(this)
    document.addEventListener("turbo:render", this.boundInit)
    this.init()
  }

  init() {
    if (this.flatpckr) {
      this.flatpckr.destroy();
    }
    this.flatpckr = flatpickr(this.inputTarget, {
      altInput: true,
      altFormat: "j F, Y",
      dateFormat: "Y-m-d",
      maxDate: "today",
    });
  }

  disconnect() {
    document.removeEventListener("turbo:render", this.boundInit)
    this.flatpckr.destroy();
  }

  clear() {
    this.flatpckr.clear();
  }

  open() {
    this.flatpckr.open();
  }

}
